import Layout from '@/layout'

const educationManage = {
    path: '/education',
    component: Layout,
    children: [
        // 考勤打卡列表
        {
            path: 'checkRecord',
            name: 'checkRecord',
            component: () => import('@/views/doctor/education/checkRecord')
        },
        // 人脸建档记录
        {
            path: 'faceRecord',
            name: 'faceRecord',
            component: () => import('@/views/doctor/education/faceRecord')
        }
    ]
}

export default educationManage
